import { LoadingButton } from '@mui/lab'
import { Box, Chip, Stack, Typography } from '@mui/material'
import { IFamilyMemberDto } from 'types'

const STATUS_LABELS: Record<IFamilyMemberDto['status'], string> = {
  active: 'Active',
  invited: 'Invited',
  removed: 'Removed',
  left: 'Left',
}

const STATUS_COLORS: Record<IFamilyMemberDto['status'], 'success' | 'warning' | 'default'> = {
  active: 'success',
  invited: 'warning',
  removed: 'default',
  left: 'default',
}

function displayName(member: IFamilyMemberDto): string {
  const fullName = [member.firstname, member.lastname].filter(Boolean).join(' ').trim()
  return fullName || member.email
}

export function FamilyMembersList({
  members,
  onRemove,
  removingMemberId,
}: {
  members: IFamilyMemberDto[]
  onRemove: (member: IFamilyMemberDto) => void
  removingMemberId?: number | null
}) {
  if (!members.length) return null

  return (
    <Stack spacing={1} sx={{ mt: 1 }}>
      {members.map((member) => {
        const isOwner = member.role === 'owner'
        const isRemoving = removingMemberId === member.id
        const subtitle = !isOwner && member.firstname ? member.email : null

        return (
          <Stack key={member.id} direction="row" alignItems="center" spacing={1}>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography variant="body2" noWrap>
                {displayName(member)}
                {isOwner && (
                  <Typography component="span" variant="caption" color="text.secondary">
                    {' '}
                    (You)
                  </Typography>
                )}
              </Typography>
              {subtitle && (
                <Typography variant="caption" color="text.secondary" noWrap>
                  {subtitle}
                </Typography>
              )}
            </Box>

            <Chip
              label={STATUS_LABELS[member.status]}
              size="small"
              color={STATUS_COLORS[member.status]}
              variant="outlined"
            />

            {!isOwner && (
              <LoadingButton
                size="small"
                color="error"
                variant="text"
                loading={isRemoving}
                onClick={() => onRemove(member)}
              >
                Remove
              </LoadingButton>
            )}
          </Stack>
        )
      })}
    </Stack>
  )
}
